import api from '@/utils/api'

const applicationServerPublicKey = process.env.VAPID_PUBLIC_KEY

export function urlB64ToUint8Array (base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4)
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/')

  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

export function initializePush () {
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    navigator.serviceWorker.ready.then((swRegistration) => {
      swRegistration.pushManager.getSubscription()
        .then((subscription) => {
          updateSubscriptionOnServer(subscription)
        })
    })
  }
}

export function compatibleBrowser () {
  return ('serviceWorker' in navigator && 'PushManager' in window)
}

export function subscribeUser () {
  const applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey)
  return new Promise((resolve, reject) => {
    navigator.serviceWorker.ready.then((swRegistration) => {
      swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: applicationServerKey
      })
        .then((subscription) => {
          updateSubscriptionOnServer(subscription, true)
          resolve(subscription)
        })
        .catch((err) => {
          console.log('Failed to subscribe the user: ', err)
          reject(err)
        })
    })
  })
}

export function unsubscribe () {
  return new Promise((resolve, reject) => {
    navigator.serviceWorker.ready.then((swRegistration) => {
      swRegistration.pushManager.getSubscription()
        .then((subscription) => {
          let isSubscribed = !(subscription === null)
          if (isSubscribed) {
            let oldSubscription = subscription.toJSON()
            subscription.unsubscribe().then(() => {
              api.post('/devices/', {
                'delete': true,
                'endpoint': oldSubscription.endpoint,
                'auth': oldSubscription.keys.auth,
                'p256dh': oldSubscription.keys.p256dh
              })
              resolve()
            })
          }
        })
    })
  })
}

function updateSubscriptionOnServer (subscription, registration) {
  if (subscription) {
    subscription = subscription.toJSON()
    if (api.defaults.headers.common['Authorization'] === undefined) {
      return
    }
    api.post('/devices/', {
      'endpoint': subscription.endpoint,
      'auth': subscription.keys.auth,
      'p256dh': subscription.keys.p256dh,
      'registration': !!registration
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/push.js